import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { getRecentPosts } from "../data/blogPosts";

export default function RightSidebar() {
  const { isDark } = useTheme();
  const recentPosts = getRecentPosts(5);

  return (
    <aside
      className={`w-72 border-l overflow-y-auto hide-scrollbar min-h-screen sticky top-0 h-screen hidden xl:block ${
        isDark ? "border-border-dark bg-background-dark" : "border-border/50"
      }`}
    >
      <div className="p-6">
        {/* Recently Updated */}
        <div>
          <h3
            className={`text-sm font-display font-semibold uppercase tracking-wider mb-4 ${
              isDark ? "text-white" : "text-text"
            }`}
          >
            Recent Posts
          </h3>
          <ul className="space-y-3">
            {recentPosts.map((post, index) => (
              <li key={index} className="group">
                <Link
                  to={`/blog/${post.slug}`}
                  className={`text-sm transition-colors duration-base leading-snug block ${
                    isDark
                      ? "text-gray-400 hover:text-primary-dark"
                      : "text-text-muted hover:text-primary"
                  }`}
                >
                  {post.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
}
